import React, {useEffect, useState} from 'react'
// Styles
import './mbsklc-style.css'
// Images
import TrashIcon from '../../assets/images/icons/trash.png'
// Actions
import { NhealthAction } from '../../_actions/action.api';


function MyBasket_ListCard({ packageData, handlerDeleteCartByID }) {

    useEffect(() => {
        // console.log('package data: ', packageData);
    })

    return (
        <div className="mbsklc-container">
            {/* title wrap */}
            <div className="title-wrap">
                <h3 className="left t-bold ts-normal">
                    {packageData.name_th}
                </h3>
                <img 
                    src={TrashIcon} 
                    onClick={() => handlerDeleteCartByID(packageData.cartid)}
                />
            </div>
            {/* detail wrap */}
            <div className="detail-wrap">
                <div className="left t-bold ts-normal">
                    ฿{Number(packageData.totalPrice).toLocaleString('th', {minimumFractionDigits: 2})}
                </div>
                <div className="right t-bold">
                    x{packageData.totalAmount}
                </div>
            </div>
        </div>
    )
}

export default MyBasket_ListCard;